import { ArtData } from '@/database/art'
import { UserShare } from '@/components/Context'

export const getUserShare = (artData: ArtData, currentAccount: string, artDataList: ArtData[]): UserShare => {
    return {
        votes: calcVotesShare(artData, currentAccount),
        claims: calcClaimShare(artData, currentAccount, artDataList),
        creator: artData.art.user.walletAddress === currentAccount ? 100 : 0,
        owner: artData.art.currentOwner === currentAccount ? 100 : 0,
        airdrop: 0,
    }
}

const calcVotesShare = (artData: ArtData, currentAccount: string): number => {
    const totalAmount = artData.votes.reduce((total: number, voteData) => {
        total += parseFloat(voteData.vote.amount ? voteData.vote.amount : '0')
        return total
    }, 0)
    const userAmount = artData.votes
        .filter((voteData) => voteData.user.walletAddress === currentAccount)
        .reduce((total: number, voteData) => {
            total += parseFloat(voteData.vote.amount ? voteData.vote.amount : '0')
            return total
        }, 0)
    return userAmount ? (userAmount / totalAmount) * 100 : 0
}

const calcClaimShare = (artData: ArtData, currentAccount: string, artDataList: ArtData[]): number => {
    if (artDataList?.length > 0) {
        const totalAmount = artData.claims.reduce((total: number, voteData) => {
            total += parseFloat(voteData.claim.amount ? voteData.claim.amount : '0')
            return total
        }, 0)

        const userAmount = artData.claims
            .filter((claimData) => claimData.user.walletAddress === currentAccount)
            .reduce((total: number, claimData) => {
                artDataList
                    .filter(
                        (artData) =>
                            artData.art.id === claimData.castingArt.id && artData.currentOwner === currentAccount,
                    )
                    .forEach(() => {
                        total += parseFloat(claimData.claim.amount ? claimData.claim.amount : '0')
                    })
                return total
            }, 0)
        return userAmount ? (userAmount / totalAmount) * 100 : 0
    }
    return 0
}
